// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__t2VQd","fileBtn":"File_fileBtn__3PbqU","closeBtn":"File_closeBtn__1ldrP","fileSelected":"File_fileSelected__v_4V7","disabled":"File_disabled__jMQJZ"};